// src/features/admin/components/settings/integrations/components/CourtSystemsTab.tsx
import React from 'react';
import {
  BuildingLibraryIcon,
  ClockIcon
} from '@heroicons/react/24/outline';

const COURT_SYSTEMS = [
  {
    name: 'Odyssey (Tyler Technologies)',
    description: 'Access to 38+ state court systems including case search, document access, and docket tracking.',
    jurisdictions: 'Texas, California, New York, and 35+ more states',
    features: ['Case search', 'Document retrieval', 'Docket tracking', 'Calendar integration']
  },
  {
    name: 'PACER / CM/ECF',
    description: 'Federal court document retrieval system. Access federal case documents and file electronically.',
    jurisdictions: 'All federal district courts',
    features: ['Document download', 'Docket search', 'Case tracking', 'RSS feeds']
  },
  {
    name: 'File & ServeXpress',
    description: 'Electronic court filing and service of process tracking.',
    jurisdictions: 'Multiple states',
    features: ['E-filing', 'Service tracking', 'Document delivery', 'Proof of service']
  },
  {
    name: 'E-FileTexas',
    description: 'Texas state court electronic filing system.',
    jurisdictions: 'All Texas state courts',
    features: ['E-filing', 'Fee payment', 'Document submission', 'Status tracking']
  }
];

const CourtSystemsTab: React.FC = () => {
  return (
    <div className="space-y-6">
      {/* Coming Soon Banner */}
      <div className="bg-amber-50 dark:bg-amber-900/10 border border-amber-200 dark:border-amber-800 rounded-lg p-6 text-center">
        <ClockIcon className="h-12 w-12 text-amber-600 dark:text-amber-400 mx-auto mb-4" />
        <h3 className="text-lg font-semibold text-amber-800 dark:text-amber-200 mb-2">
          Court Systems Integration - Coming in Phase 3
        </h3>
        <p className="text-sm text-amber-700 dark:text-amber-300 max-w-2xl mx-auto">
          Connect EdgeLex directly to court systems for seamless case tracking, document retrieval, and docket monitoring. 
          This feature is scheduled for Phase 3 of development (Weeks 19-26).
        </p>
      </div>

      {/* Preview of Available Integrations */}
      <div>
        <h4 className="text-md font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
          <BuildingLibraryIcon className="h-5 w-5 mr-2 text-lex-accent" />
          Planned Court System Integrations
        </h4>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {COURT_SYSTEMS.map((system, index) => (
            <div
              key={index}
              className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-5 opacity-75"
            >
              <h5 className="text-sm font-semibold text-gray-900 dark:text-white mb-2">
                {system.name}
              </h5>
              <p className="text-xs text-gray-600 dark:text-gray-400 mb-3">
                {system.description}
              </p>
              <div className="mb-3">
                <span className="text-xs font-medium text-gray-500 dark:text-gray-400">Jurisdictions:</span>
                <p className="text-xs text-gray-600 dark:text-gray-300">{system.jurisdictions}</p>
              </div>
              <div className="flex flex-wrap gap-1">
                {system.features.map((feature, idx) => (
                  <span
                    key={idx}
                    className="text-xs px-2 py-0.5 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded"
                  >
                    {feature}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Interest Form */}
      <div className="bg-lex-accent-soft dark:bg-lex-accent-soft border border-lex-accent dark:border-lex-accent rounded-lg p-4">
        <h5 className="text-sm font-semibold text-lex-accent dark:text-lex-accent mb-2">
          Interested in early access?
        </h5>
        <p className="text-xs text-lex-accent dark:text-lex-accent mb-3">
          Let us know which court systems are most important to your practice and we'll prioritize accordingly.
        </p>
        <button className="text-xs text-lex-accent dark:text-lex-accent font-medium hover:underline">
          → Request Early Access
        </button>
      </div>
    </div>
  );
};

export default CourtSystemsTab;
